import { Component, OnInit } from '@angular/core';
import { DictionaryService } from './dictionary.service';
import { DictionaryEntry } from './types/dictionary-list.dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DictionaryGroup } from './types/dictionary-groups.enum';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../shared/services/auth.service';
import { Resources } from '../shared/enums/resources.enum';

@Component({
   selector: 'app-dictionary',
   templateUrl: './dictionary.component.html',
   styleUrls: ['./dictionary.component.css']
})
export class DictionaryComponent implements OnInit {
   Resources = Resources;

   dataSource: DictionaryEntry[] = [];

   columns: string[] = ['group', 'code', 'value', 'edit'];

   form: FormGroup;

   groups = Object.values(DictionaryGroup);

   modifyInProgress = false;

   constructor(
      private dictService: DictionaryService,
      private fb: FormBuilder,
      private snackBar: MatSnackBar,
      private authService: AuthService
   ) {
      this.form = this.fb.group({
         group: ['', Validators.required],
         code: ['', Validators.required],
         value: ['', Validators.required]
      });
   }

   ngOnInit(): void {
      this.loadDict();
   }

   loadDict() {
      this.dictService.list({}).subscribe(
         res => {
            this.dataSource = res;
         },
         error => {
            this.handleError(error.toString());
         }
      );
   }

   onSubmit() {
      if (this.modifyInProgress) {
         const modifyPayload = {
            group: this.form.controls.group.value,
            code: this.form.controls.code.value,
            value: this.form.controls.value.value
         };

         this.dictService.update(modifyPayload).subscribe(
            () => {
               this.snackBar.open(`A sor sikeresen módosítva!`, 'Ok', {
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  duration: 5000
               });
               this.loadDict();
               this.formReset();
               // Alaphelyzetbe állítás
            },
            error => {
               this.handleError(error.toString());
            }
         );
      } else {
         this.dictService.create(this.form.value).subscribe(
            () => {
               this.snackBar.open(`A sor sikeresen létrehozva!`, 'Ok', {
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  duration: 5000
               });
               this.loadDict();
               this.formReset();
            },
            error => {
               this.handleError(error.toString());
            }
         );
      }
   }

   onEdit(item: DictionaryEntry) {
      this.form.patchValue(item);
      this.modifyInProgress = true;
      this.form.controls.code.disable();
   }

   formReset() {
      this.form.reset();
      this.form.markAsUntouched();
      this.form.controls.code.enable();
      this.modifyInProgress = false;
   }

   onDiscard() {
      this.formReset();
   }

   onDelete(item: DictionaryEntry) {
      this.dictService
         .delete({
            code: item.code,
            group: item.group
         })
         .subscribe(
            () => {
               this.snackBar.open(`A sor sikeresen törölve!`, 'Ok', {
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  duration: 5000
               });
               this.loadDict();
            },
            error => {
               this.handleError(error.toString());
            }
         );
   }

   handleError(errText: string) {
      this.snackBar.open(errText, 'Error', {
         horizontalPosition: 'center',
         verticalPosition: 'top',
         duration: 5000
      });
   }

   hasResource(resource: string): boolean {
      return this.authService.hasResource(resource);
   }
}
